import { ProjectSettingsForm } from "@/forms/project-settings-form";
import { Panels } from "@msuite/ui/panels";
import { OrganizationGeneralInformationForm } from "./organization-general-information-form";
import { OrganizationSettingsForm } from "./organization-settings-form";
import { OrganizationSettingsInvitationCodes } from "./organization-settings-invitation-codes";

export function OrganizationSettingsGeneral() {
	/** Render */
	return (
		<Panels>
			<Panels.Panel flex={1}>
				<OrganizationSettingsInvitationCodes />
			</Panels.Panel>
			<Panels.Panel flex={2}>
				<OrganizationGeneralInformationForm />
				<OrganizationSettingsForm />
				<ProjectSettingsForm scope="default" />
			</Panels.Panel>
		</Panels>
	);
}
